import * as React from "react";
import moment from "moment";

const TYPE_CONFIG = {
  registration: { emoji: "👤", color: "#3b82f6", bg: "#eff6ff", label: "Registration" },
  payment:      { emoji: "💰", color: "#10b981", bg: "#ecfdf5", label: "Payment" },
  alert:        { emoji: "⚠️", color: "#f59e0b", bg: "#fffbeb", label: "Alert" },
  general:      { emoji: "🔔", color: "#8b5cf6", bg: "#f5f3ff", label: "General" },
};

export default function NotificationCard({
  item,
  isMarkingId,
  isDeletingId,
  onMarkRead,
  onDeleteConfirm,
}) {
  const cfg = TYPE_CONFIG[item.type] || TYPE_CONFIG.general;
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      className={`nc-card ${!item.read ? "nc-card--unread" : ""} ${isDeletingId ? "nc-card--removing" : ""}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Unread accent bar */}
      {!item.read && <span className="nc-accent" style={{ background: cfg.color }} />}

      {/* Icon */}
      <div
        className="nc-icon"
        style={{ background: cfg.bg, color: cfg.color }}
      >
        <span className="nc-emoji">{cfg.emoji}</span>
        {!item.read && (
          <span className="nc-dot" style={{ background: cfg.color }} />
        )}
      </div>

      {/* Body */}
      <div className="nc-body">
        <div className="nc-top">
          <div className="nc-left">
            <span
              className="nc-type-tag"
              style={{ background: cfg.bg, color: cfg.color }}
            >
              {cfg.label}
            </span>
            <h3 className="nc-title">{item.title}</h3>
          </div>
          <span className="nc-time">{moment(item.date).fromNow()}</span>
        </div>
        <p className="nc-msg">{item.message}</p>
        <span className="nc-date">
          {moment(item.date).format("DD MMM YYYY · h:mm A")}
        </span>
      </div>

      {/* Actions */}
      <div className={`nc-actions ${hovered ? "nc-actions--visible" : ""}`}>
        {/* Read status pill */}
        <span className={`nc-pill ${item.read ? "nc-pill--read" : "nc-pill--unread"}`}>
          {item.read ? "Read" : "Unread"}
        </span>

        {/* Mark read btn */}
        {!item.read && (
          <button
            className="nc-btn nc-btn--check"
            onClick={() => onMarkRead(item.id)}
            disabled={isMarkingId}
            title="Mark as read"
          >
            {isMarkingId ? (
              <span className="nc-spin" />
            ) : (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            )}
          </button>
        )}

        {/* Delete btn */}
        <button
          className="nc-btn nc-btn--delete"
          onClick={() => onDeleteConfirm(item.id)}
          disabled={isDeletingId}
          title="Delete"
        >
          {isDeletingId ? (
            <span className="nc-spin" />
          ) : (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14H6L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4h6v2" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}